import Api from "@/lib/Api";

export default {
	data: {
		list: [],
	},

	error: function(text, callback) {
		if (text == 'unauthorized') {
			Api.logout();
			return;
		}

		if (!callback) callback = false;

		if (callback === true) {
			callback = function() {};
		}

		let notif = {
			type: "error",
			text: text,
			callback: callback
		};
		this.data.list.push(notif);

		if (callback == false) {
			setTimeout(() => {
				for (let idx in this.data.list) {
					if (this.data.list[idx] == notif) {
						this.data.list.splice(idx, 1);
					}
				}
			}, 7000);
		}
	},

	success: function(text, callback) {
		if (!callback) callback = false;

		if (callback === true) {
			callback = function() {};
		}

		let notif = {
			type: "success",
			text: text,
			callback: callback
		};
		this.data.list.push(notif);
		
		if (callback == false) {
			setTimeout(() => {
				for (let idx in this.data.list) {
					if (this.data.list[idx] == notif) {
						this.data.list.splice(idx, 1);
					}
				}
			}, 7000);
		}
	},

	default: function(text, callback) {
		if (!callback) callback = false;

		if (callback === true) {
			callback = function() {};
		}

		let notif = {
			type: "default",
			text: text,
			callback: callback
		};
		this.data.list.push(notif);

		if (callback == false) {
			setTimeout(() => {
				for (let idx in this.data.list) {
					if (this.data.list[idx] == notif) {
						this.data.list.splice(idx, 1);
					}
				}
			}, 7000);
		}
	}
}